import React from "react";
import { Adsense } from "@ctrl/react-adsense";
import "./AdSenseSlot.css";

const AD_CLIENT = "ca-pub-7640498129575554";
// Replace with your ad unit slot ID from AdSense → Ads → By ad unit
const AD_SLOT = "9782744681";

function AdSenseSlot() {
  return (
    <div
      className="AdSenseSlot-wrapper"
      role="complementary"
      aria-label="Advertisement"
    >
      <Adsense
        className="AdSenseSlot"
        client={AD_CLIENT}
        slot={AD_SLOT}
        adTest={process.env.NODE_ENV === "development" ? "on" : undefined}
      />
    </div>
  );
}

export default AdSenseSlot;
